import { getModuleVersionProps } from '../../interfaces/module/getModuleVersionURLProps'
// import { mobileVersions } from '../init/consts/versions'
import { IMicrofront, MinimalVersion } from '../../interfaces/MFE/IMicrofront'
import { platform } from '../device/platform'

export function getFeatureUrl (
  feat: IMicrofront | undefined, 
  microfronts: {
    discovered: IMicrofront[]
    downloaded?: MinimalVersion[]
}): string {
  if ( feat === undefined ) return ''
  if ( platform !== 'web' ){
    const alreadyDownloaded = microfronts.downloaded?.find( mfe => mfe.mfe_id === feat.mfe_id && mfe.version === feat.version )
    if ( alreadyDownloaded ){
      return `http://localhost:9000/modules/${alreadyDownloaded.mfe_id}/${alreadyDownloaded.version}/${feat.data.entry_file}`
    } else {
      const anyOtherVersionDownloaded = microfronts.downloaded?.find( mfe => mfe.mfe_id === feat.mfe_id )
      if ( anyOtherVersionDownloaded ){
        return `http://localhost:9000/modules/${anyOtherVersionDownloaded.mfe_id}/${anyOtherVersionDownloaded.version}/${feat.data.entry_file}`
      }
    }
  } else {
    return `${MFE_SOURCES_URL}/${feat.location}${feat.data.entry_file}`
  }

  return ''
}

export function getModuleVersionURL ({ featureId, featureName, microfronts }: getModuleVersionProps): string {
  return getFeatureUrl(getModuleVersion({ featureId, featureName, microfronts }), microfronts)
}

export function getModuleVersion ({ featureId, featureName, microfronts }: getModuleVersionProps): IMicrofront | undefined {
  return microfronts.discovered.find(f => f.mfe_id === featureId || f.mfe_name === featureName)
}